import { computed } from 'vue';
import type { Files, File, Product, DocumentType } from '~/types';

export default function (product: Product) {
    const preferredLanguage = usePreferredLanguage();

    const allDocs =
        Array.isArray(product.documents) && product.documents.length > 0
            ? product.documents
            : [];
    const filteredDocs = computed<Files>(() =>
        allDocs.filter(file =>
            preferredLanguage.value.length > 0
                ? preferredLanguage.value.includes(file.language) ||
                  file.language === 'en' // always include english
                : true
        )
    );

    const filteredGroupedByType = computed<Record<DocumentType, Array<File>>>(() => {
        const groupedByType: Record<string, Array<File>> = {};
        filteredDocs.value.forEach((file: File) => {
            groupedByType[file.type] = groupedByType[file.type] || [];
            groupedByType[file.type].push(file);
        });
        return groupedByType;
    });

    return {
        allDocs,
        filteredDocs,
        filteredGroupedByType,
    };
}
